export const global: any = typeof window !== 'undefined' ? window : {};
